import { Link, Navigate, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { fetchAccountMe } from "../api/client.js";
import { useLayoutTitle } from "../context/LayoutTitleContext.jsx";
import { hasMarketplaceJwtCredentials, isVitrineLoggedIn } from "../lib/wicoopProfileStorage.js";
import { fetchProfileCompletionRedirect } from "../utils/profileCompletion.js";
import styles from "./ProfilePage.module.css";

export default function ProfilePage() {
  const navigate = useNavigate();
  const { setPageTitle } = useLayoutTitle();
  const [me, setMe] = useState(null);

  useEffect(() => {
    setPageTitle("Профиль");
    return () => setPageTitle(null);
  }, [setPageTitle]);

  useEffect(() => {
    let cancelled = false;
    fetchProfileCompletionRedirect("/profile").then((path) => {
      if (!cancelled && path) navigate(path, { replace: true });
    });
    return () => {
      cancelled = true;
    };
  }, [navigate]);

  useEffect(() => {
    if (!hasMarketplaceJwtCredentials()) return;
    let cancelled = false;
    fetchAccountMe()
      .then((data) => {
        if (!cancelled) setMe(data);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  if (!isVitrineLoggedIn()) {
    return <Navigate to="/profile/login" replace />;
  }

  const name = [me?.first_name, me?.last_name].filter(Boolean).join(" ").trim();

  return (
    <div className={`${styles.page} ${styles.pageProfile}`}>
      <div className={styles.profileHead}>
        {name ? <h2 className={styles.profileName}>{name}</h2> : null}
        {me?.phone ? <p className={styles.profilePhone}>{me.phone}</p> : null}
      </div>
      <nav className={styles.menu} aria-label="Разделы профиля">
        <Link to="/profile/active" className={styles.menuItem}>
          Активные раздачи <span aria-hidden>→</span>
        </Link>
        <Link to="/profile/history" className={styles.menuItem}>
          История участий <span aria-hidden>→</span>
        </Link>
        <Link to="/profile/settings" className={styles.menuItem}>
          Настройки <span aria-hidden>→</span>
        </Link>
      </nav>
    </div>
  );
}
